import { z } from "zod";
import { EditApprovalPolicySchema, } from "../contracts/edit-matrix.js";
import { getEditFieldDeclaration } from "./edit-matrix-runtime.js";
export const SAFE_EDIT_PUBLISH_DENY_REASON = {
    QA_NOT_PASSED: "PUBLISH_QA_NOT_PASSED",
    AGENCY_APPROVAL_REQUIRED: "PUBLISH_AGENCY_APPROVAL_REQUIRED",
    PUBLISH_GATE_REQUIRED: "PUBLISH_GATE_APPROVAL_REQUIRED",
    UNKNOWN_FIELD_FAIL_CLOSED: "PUBLISH_UNKNOWN_FIELD_FAIL_CLOSED",
};
export const SafeEditReleaseResultV1Schema = z
    .object({
    schemaVersion: z.literal("safe-edit-release-result.v1.0"),
    outcome: z.enum(["RELEASED", "DENIED"]),
    approvalPolicy: EditApprovalPolicySchema,
    actorId: z.string().min(1),
    occurredAt: z.string().datetime(),
    reasonCode: z.string().min(1),
    fieldPaths: z.array(z.string()).default([]),
})
    .strict();
function strictestApprovalPolicy(policies) {
    if (policies.some((p) => p === "PUBLISH_GATE"))
        return "PUBLISH_GATE";
    if (policies.some((p) => p === "AGENCY_REVIEW"))
        return "AGENCY_REVIEW";
    return "AUTO_CLIENT_L1";
}
/**
 * Edit→publish policy matrix: export/release requires QA pass plus approval tier
 * from declared matrix metadata (strictest policy wins).
 */
export function evaluateEditPublishEligibility(input) {
    const policies = [];
    for (const fieldPath of input.fieldPaths) {
        const declaration = getEditFieldDeclaration(fieldPath, input.declarations);
        if (!declaration) {
            return {
                allowed: false,
                strictestPolicy: "PUBLISH_GATE",
                reasonCode: SAFE_EDIT_PUBLISH_DENY_REASON.UNKNOWN_FIELD_FAIL_CLOSED,
            };
        }
        policies.push(declaration.approvalPolicy);
    }
    const strictestPolicy = strictestApprovalPolicy(policies);
    if (!input.qaPassed) {
        return {
            allowed: false,
            strictestPolicy,
            reasonCode: SAFE_EDIT_PUBLISH_DENY_REASON.QA_NOT_PASSED,
        };
    }
    if (strictestPolicy === "PUBLISH_GATE" && !input.publishGateGranted) {
        return {
            allowed: false,
            strictestPolicy,
            reasonCode: SAFE_EDIT_PUBLISH_DENY_REASON.PUBLISH_GATE_REQUIRED,
        };
    }
    if (strictestPolicy === "AGENCY_REVIEW" && !input.agencyApprovalGranted) {
        return {
            allowed: false,
            strictestPolicy,
            reasonCode: SAFE_EDIT_PUBLISH_DENY_REASON.AGENCY_APPROVAL_REQUIRED,
        };
    }
    return {
        allowed: true,
        strictestPolicy,
        reasonCode: "PUBLISH_ALLOWED",
    };
}
export function recordSafeEditReleaseResult(params) {
    return SafeEditReleaseResultV1Schema.parse({
        schemaVersion: "safe-edit-release-result.v1.0",
        outcome: params.eligibility.allowed ? "RELEASED" : "DENIED",
        approvalPolicy: params.eligibility.strictestPolicy,
        actorId: params.actorId,
        occurredAt: params.occurredAt,
        reasonCode: params.eligibility.reasonCode,
        fieldPaths: [...params.fieldPaths],
    });
}
//# sourceMappingURL=edit-publish-policy.js.map